import { render } from "./SearchResultItem.vue?vue&type=template&id=6c2323b7&scoped=true&ts=true"
import script from "./SearchResultItem.vue?vue&type=script&lang=ts"
export * from "./SearchResultItem.vue?vue&type=script&lang=ts"

import "./SearchResultItem.vue?vue&type=style&index=0&id=6c2323b7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2323b7"]])

export default __exports__